import script from "./CasesCompleted.vue?vue&type=script&setup=true&lang=ts"
export * from "./CasesCompleted.vue?vue&type=script&setup=true&lang=ts"

import "./CasesCompleted.vue?vue&type=style&index=0&id=242a5062&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242a5062"]])

export default __exports__